import React, { useEffect, useState } from 'react';
import { Button, Stack, TextField, Typography, useMediaQuery } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { FormControl, RadioGroup, FormControlLabel, Radio, Select, MenuItem } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { baseUrl } from '../lib/const';

// const questions = [
//     { id: 0, text: "Efficienza di base:", type: 'db' },
//     { id: 1, text: "Fonte di approvvigionamento:", options: ['Lago', 'Canale', 'Pozzo', 'Rete turbata consortile'], type: 'select' },
//     { id: 2, text: "E' presente un sistema di misura e conteggio dei volumi prelevati", options: ['Sì', 'No'], type: 'radio' },
//     { id: 3, text: 'Che tipo di filtrazione principale viene utilizzata?', options: ['Cartuccia a dischi', 'Cartuccia a dischi', 'Graniglia', 'Idrociclone'], type: 'select' },
//     { id: 4, text: 'Schema di filtraggio:', options: ['Unica unità filtrante', 'Unità filtranti che operano in sequenza'], type: 'select' },
//     { id: 5, text: "Vi è la possibilità di effettuare un controlavaggio automatico?", options: ['No', 'Sì, su RETE', 'Sì, su DISCHI', 'Sì, su GRANIGLIA'], type: 'select' },
//     { id: 6, text: 'Ci sono filtri di sicurezza a valle del filtraggio principale?', options: ['Sì', 'No'], type: 'radio' },
//     { id: 7, text: "Indica la tua pressione d'esercizio (bar o atm):", type: 'text' },
//     { id: 8, text: 'Utilizzi un riduttore di pressione consono per le caratteristiche di funzionamento delle linee irrigue?', options: ['Sì', 'No'], type: 'radio' },
//     { id: 9, text: "Utilizzi ali gocciolanti autocompensanti?", options: ['Sì', 'No'], type: 'radio' },
//     { id: 10, text: 'Stazione Agrometeorologica per la stima dei fabbisogni idrici:', options: ['Sì', 'No'], type: 'radio' },
//     { id: 11, text: 'Presenza Pluviometro:', options: ['Sì, con lettura manuale', 'Sì, con invio dati IoT', 'No'], type: 'radio' },
//     { id: 12, text: "Strumenti che registrano dati per generare blocchi dell'irrigazione / allarmi / notifiche:", options: ['No', 'Sensore pioggia', 'Pressostati sulle linee', 'Sensore di radiazione', 'Contalitri', '2 o più dei suddetti'], type: 'select' },
//     { id: 13, text: 'DSS IRRIGUO:', options: ['Sì', 'No'], type: 'radio' },
//     { id: 14, text: "Programmatore irriguo interfacciabile programmabile da remoto con la possibilità di irrigare su condizione (tempo, volume, umidità del suolo):", options: ['Sì', 'No'], type: 'radio' },// Add more questions as needed
//     { id: 15, text: 'Sensoristica di umidità del suolo:', options: ['Sì', 'No'], type: 'radio' },
//     { id: 16, text: 'Azienda che effettua la fertirrigazione:', options: ['Sì', 'No'], type: 'radio' },
//     { id: 17, text: 'Impianto fertirriguo manuale (venturi, pompa idraulica, dosatrice proporzionale):', options: ['Sì', 'No'], type: 'radio' },
//     { id: 18, text: 'Banchi fertirrigui automatici (kit di fertirrigazione con vari livelli di automazione):', options: ['Sì', 'No'], type: 'radio' },
// ];

const Microirrigazione = () => {
    const [answers, setAnswers] = useState({});
    const navigate = useNavigate();
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'))
    const [questions, setQuestions] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch(`${baseUrl}domande?page=microirrigazione`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }

                const data = await response.json();
                console.log(data)
                setQuestions(data);
            } catch (error) {
                console.error('Error fetching data:', error.message);
            }
        };

        fetchData();
    }, [])

    const formStyle = {
        maxWidth: isSmallScreen ? '90vw' : '',
        width: isSmallScreen ? '' : '50vw',
    };

    const handleAnswerChange = (questionId, answer) => {
        setAnswers((prevAnswers) => ({ ...prevAnswers, [questionId]: answer }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const response = await fetch(`${baseUrl}microirrigazione/efficienza`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ answers })
        })

        let efficiency;
        let parsedAnswers;

        if (response.ok) {
            const data = await response.json()
            efficiency = data.totalEfficiency
            parsedAnswers = data.answers
            setAnswers(data.answers)
        }

        navigate('/risultati', { state: { answers: parsedAnswers, page: 'Microirrigazione', questions, efficiency: Math.round(efficiency) } })
    };

    const isFormValid = () => {
        // Check if there is a valid answer for each question
        return questions.every((question) => {
            const answer = answers[question.id];
            switch (question.type) {
                case 'radio':
                    return answer !== undefined && answer !== '';
                case 'select':
                    return answer !== undefined && answer !== '';
                case 'text':
                    return answer !== undefined && answer.trim() !== '';
                case 'db':
                    return true;
                default:
                    return false;
            }
        });
    };

    const renderQuestionType = (question) => {
        switch (question.type) {
            case 'radio':
                return (
                    <RadioGroup
                        sx={{ width: "50%", paddingLeft: "15px" }}
                        value={answers[question.id] || ''}
                        onChange={(e) => handleAnswerChange(question.id, e.target.value)}
                    >
                        {question.options.map((option, index) => (
                            <FormControlLabel
                                key={index}
                                value={option}
                                control={<Radio />}
                                label={option}
                            />
                        ))}
                    </RadioGroup>
                );
            case 'select':
                return (
                    <div style={{ width: "50%", maxWidth: "50%", paddingLeft: "15px" }}>
                        <Select
                            sx={{ width: "100%" }}
                            value={answers[question.id] || ''}
                            onChange={(e) => handleAnswerChange(question.id, e.target.value)}
                        >
                            {question.options.map((option, index) => (
                                <MenuItem key={index} value={option} sx={{ whiteSpace: 'normal' }}>
                                    {option}
                                </MenuItem>
                            ))}
                        </Select>
                    </div>
                );
            case 'text':
                return (
                    <TextField
                        sx={{ width: "50%", paddingLeft: "15px" }}
                        value={answers[question.id] || ''}
                        onChange={(e) => {
                            const numericValue = e.target.value.replace(/[^0-9,.]/g, '');
                            handleAnswerChange(question.id, numericValue)
                        }}
                        id="outlined-basic"
                        variant="outlined"
                        inputProps={{ pattern: "[0-9,.]*" }} />
                );
            case 'db':
                return (
                    <Typography sx={{ width: "50%", paddingLeft: "15px" }}>
                        {question.weights[0]}
                    </Typography>
                );
            default:
                return null; // or handle unknown question types
        }
    };

    return (
        <div style={{ display: "flex", justifyContent: "center", marginTop: "40px" }}>
            <form onSubmit={handleSubmit} style={formStyle}>
                <Stack direction="column">
                    <Typography variant="h1" color='primary' sx={{ fontSize: '28px', fontWeight: 'bold', marginBottom: "20px" }}>Inserire dati microirrigazione</Typography>
                    {questions.map((question) => (
                        <FormControl key={question.id} component="fieldset" sx={{ marginY: "10px" }}>
                            <Stack direction="row">
                                <legend style={{ width: "50%", fontWeight: question.id === 0 ? 'bold' : '', textAlign: "right" }}>{question.text}</legend>
                                {renderQuestionType(question)}
                            </Stack>
                        </FormControl>
                    ))}
                    <div>
                        <Button disabled={!isFormValid()} sx={{ marginY: "40px", width: "200px", justifyContent: "center" }} type="submit" variant="contained" color="primary">
                            CALCOLA EFFICIENZA
                        </Button>
                    </div>
                </Stack>
            </form>
        </div>
    );
};

export default Microirrigazione;
